module.exports = __webpack_public_path__ + "img/main.0625a871.png";